<template>
  <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
    <div>
      <div class="flex flex-nowrap">
        <h3 class="flex-auto text-lg leading-6 font-medium text-gray-900 mb-3">
          Functional Cookies
        </h3>
        <div class="flex-shrink">
          <SwitchInput
            :on="true"
            :disabled="true"
            :emit-on-load="false"
            class="flex items-center"
            v-slot:before="props"
          >
            <span class="mr-2">
              <span v-if="props.on">On</span>
              <span v-else>Off</span>
            </span>
          </SwitchInput>
        </div>
      </div>
      <p>
        Functional Cookies are enabled by default at all times so that we can
        save your preferences for cookie settings and ensure site works and
        delivers best experience.
      </p>
    </div>
    <div>
      <div class="flex flex-nowrap">
        <h3 class="flex-auto text-lg leading-6 font-medium text-gray-900 mb-3">
          3rd Party Cookies
        </h3>
        <div class="flex-shrink">
          <SwitchInput
            :on="!isSet('3rd_party_consent')"
            :emit-on-load="false"
            @change="change('3rd_party_consent', $event)"
            class="flex items-center"
            v-slot:before="props"
          >
            <span class="mr-2">
              <span v-if="props.on">On</span>
              <span v-else>Off</span>
            </span>
          </SwitchInput>
        </div>
      </div>
      <p>
        This website uses Google Analytics to collect anonymous information such
        as the number of visitors to the site, and the most popular pages.<br />
        Keeping this cookie enabled helps us to improve our website.
      </p>
    </div>
  </div>
</template>
<script>
import BaseCookie from './BaseCookie';
import SwitchInput from '../SwitchInput';
export default {
  name: 'CookieSetup',
  mixins: [BaseCookie],
  components: { SwitchInput },
  methods: {
    change(type, value) {
      if (!value) {
        this.add(type);
      } else {
        this.remove(type);
      }
      this.add('cookie_consent');
    },
  },
};
</script>
